import type { UserCredential } from "firebase/auth";
import api from "api";
import { session } from "$stores/auth";
import { alerts } from "$stores/alert";

export async function createUser(user: UserCredential, captcha: string) {
  let success = false;
  try {
    const response = await api.apiUsersCreateUserFromToken(
      { createUserSerialiser: { captcha: captcha } },
      {
        headers: { Authorization: `Bearer ${await user.user.getIdToken()}` },
      }
    );
    if (response.status === 201) {
      success = true;
    }
    // reinit auth to get update user and check email verification
    await session.init();
  } catch (error) {
    console.log("There was an error creating the user", error);
    user.user.delete();
    // got a bad email but put them off the scent
    alerts.error("Invalid email or password");
  }
  return success;
}
